<template>
  <header class="header-container">
    <!-- Background Image from API -->
    <div class="background-image">
      <img
        v-if="heroImage"
        :src="heroImage"
        :alt="heroTitle"
      />
      <div v-else class="image-placeholder" />
    </div>

    <!-- Overlay -->
    <div class="video-overlay"></div>

    <!-- Header Content -->
    <div class="header-content">
      <div class="content-wrapper">
        <div class="cover-left">
          <span class="eyebrow">AL SHOLA AMERICAN SCHOOL</span>
          <h1 class="cover-title">
            {{ formattedTitle }}
          </h1>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import api from '@/services/api';
import { mediaUrl } from '@/services/media';

export default {
  name: 'ContactHeader',
  data() {
    return {
      heroTitle: 'REPORTING CHANNELS',
      heroImage: null,
    };
  },
  computed: {
    formattedTitle() {
      return this.heroTitle;
    },
  },
  async created() {
    try {
      const data = await api.getContactPage();
      const page = data?.page || data;
      if (page?.hero_title) this.heroTitle = page.hero_title;
      // ← Run through mediaUrl so /media/ paths are always resolved
      //   to the correct backend host (handles relative, absolute, wrong-port URLs)
      if (page?.hero_image) this.heroImage = mediaUrl(page.hero_image);
    } catch (e) {
      console.warn('[ContactHeader] Could not load page data:', e.message);
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* ── Container ── */
.header-container {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 600px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── Background ── */
.background-image {
  position: absolute;
  inset: 0;
  z-index: 1;
}

.background-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
}

/* ── Overlay ── */
.video-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(192, 33, 48, 0.65) 0%,
    rgba(247, 240, 43, 0.25) 100%
  );
  z-index: 2;
}

/* ── Content ── */
.header-content {
  position: relative;
  z-index: 3;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 48px 32px;
}

.content-wrapper {
  max-width: 900px;
  width: 100%;
  animation: fadeInUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.cover-left {
  max-width: 60%;
  color: white;
  text-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
}

.eyebrow {
  display: block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 3px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 12px;
  font-family: 'Courier New', monospace;
  text-transform: uppercase;
}

.cover-title {
  font-size: clamp(48px, 8vw, 88px);
  font-weight: 900;
  line-height: 0.95;
  letter-spacing: -2px;
  white-space: pre-line;
  color: #fff;
}

/* ── Animations ── */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .cover-left {
    max-width: 100%;
  }
  .cover-title {
    font-size: 48px;
    letter-spacing: -1px;
  }
  .header-content {
    padding: 32px 20px;
  }
}

@media (max-width: 480px) {
  .cover-title {
    font-size: 36px;
  }
  .eyebrow {
    font-size: 10px;
  }
}
</style>